import React from 'react';


function AboutBoldPhrase({ about }) {
    const bolded = about.replace("TIP - Manila mechanical engineering undergraduate", "<b>TIP - Manila mechanical engineering undergraduate</b>")
                        .replace("Avion School Fullstack Web Development graduate", "<b>Avion School Fullstack Web Development graduate</b>")
                        .replace("extensive knowledge in React and Ruby on Rails", "<b>extensive knowledge in React and Ruby on Rails</b>")
    return <p className="main-font text-base pt-0 md:pt-7 md:pb-6 leading-7 tracking-wider" dangerouslySetInnerHTML={{ __html: bolded }} />;
}

export default AboutBoldPhrase;